import { Navigate, Route, Routes } from "react-router-dom";
import { CONFIGS } from "./configs";
import Add from "./Add";
import List from "./List";
import ProtectedRoute from "routes/ProtectedRoutes";

const Brands = () => {
  return (
    <Routes>
      <Route index element={<Navigate to={CONFIGS.routes.base + CONFIGS.routes.list} />} />
      <Route path={CONFIGS.routes.list} element={<List />} />
      <Route path={CONFIGS.routes.add} element={<ProtectedRoute element={<Add />} permissions={[`create:${CONFIGS.apiName}`]} />} />
      <Route path={CONFIGS.routes.edit} element={<ProtectedRoute element={<Add />} permissions={[`update:${CONFIGS.apiName}`]} />} />
    </Routes>
  );
};

export default Brands;
